import { Form, Modal, notification, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  addStudentToInternship,
  getInternshipById,
  getInternships,
  getStudentsByInternshipId,
} from "store/slices/internshipsSlice";
import { closeModal } from "store/slices/modalsSlice";
import { getStudents } from "store/slices/studentsSlice";

const AddStudentToInternshipModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form?.useForm();
  const {
    isModalOpen,
    modalType,
    modalProps: { internshipId },
  } = useSelector((state) => state?.modals);
  const { internship, loading } = useSelector((state) => state?.internships);
  const { students } = useSelector((state) => state?.students);
  const open = isModalOpen && modalType === "add_student_to_internship";
  useEffect(() => {
    if (open) {
      dispatch(getStudentsByInternshipId(internshipId));
      dispatch(getStudents());
    }
  }, [dispatch, internshipId, open]);

  const onSubmit = async (values) => {
    try {
      await dispatch(
        addStudentToInternship({
          studentId: values?.studentId,
          internshipId,
        })
      )?.unwrap();
      notification?.success({
        message: t("internships.addStudent.success"),
      });
      dispatch(getInternshipById(internshipId));
      dispatch(closeModal());
    } catch (error) {
      notification?.error({
        message: t("internships.addStudent.error"),
        description: error,
      });
    }
  };

  const studentsList = students?.filter(
    (student) =>
      !internship?.students?.find(
        (internshipStudent) => internshipStudent?.studentId === student?._id
      )
  );

  return (
    <Modal
      title={t("internships.addStudent.title")}
      open={open}
      onCancel={() => dispatch(closeModal())}
      onOk={() => form?.submit()}
      afterClose={() => form?.resetFields()}
    >
      <Form
        id="add_student_to_internship_form"
        layout="vertical"
        onFinish={onSubmit}
        form={form}
        disabled={loading}
      >
        <Form.Item
          label={t("internships.addStudent.label")}
          name="studentId"
          rules={[
            {
              required: true,
              message: t("internships.addStudent.error.required"),
            },
          ]}
        >
          <Select>
            {studentsList?.map((student) => (
              <Select.Option key={student?._id} value={student?._id}>
                {student?.fullName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddStudentToInternshipModal;
